<template>
  <div class="page-container">
    <!-- 头部组件 -->
    <Header></Header>

    <!-- 顶部图片 -->
    <div class="top-img-wrapper">
      <img class="wx" src="../../assets/picture/1920_about.png" alt="背景图" />
    </div>

    <!-- 彈簧床墊區域 -->
    <section v-if="sfc && sfc.length" class="mattress-section">
      <div class="section-title">
        <h2 class="main-title">梳化床</h2>
        <p class="sub-title">可定制規格尺寸</p>
      </div>

      <div class="mattress-list">
        <div 
          class="mattress-item" 
          v-for="item of sfc" 
          :key="item.index || item.prod_sn" 
          @click="openBox(item.prod_sn)"
        >
          <el-image 
            :src="item.url" 
            alt="床墊圖片"
            fit="cover"
            lazy
            class="item-img"
          >
            <!-- 加載占位 -->
            <template #placeholder>
              <div class="image-placeholder">加載中...</div>
            </template>
            <!-- 加載失敗占位 -->
            <template #error>
              <div class="image-error">圖片加載失敗</div>
            </template>
          </el-image>
          <p class="item-desc">{{ item.prod_des }}</p>
        </div>
      </div>
    </section>

    <!-- 底部组件 -->
    <Footer></Footer>

    <!-- 彈窗組件 -->
    <Box
      :dialogVisible="box.dialogVisible"
      :goods_id="box.goods_id"
      @close="boxClose"
    ></Box>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Box from "@/components/Box";

export default {
  name: "Contact",
  components: { Header, Footer, Box },
  data() {
    return {
      company_sn: "R",
      cd_dt: "https://nicedream.top:8202/gw_lmm/cd1.jpg",
      sfc: [],
      box: {
        dialogVisible: false,
        goods_id: "",
      },
    };
  },
  created() {
    if (sessionStorage.getItem("company_sn")) {
      this.company_sn = sessionStorage.getItem("company_sn");
      this.queryProd();
    }
  },
  methods: {
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    queryProd() {
      this.$api
        .queryprod({
          company_sn: this.company_sn,
          category_sn: "10005",
          high: 0,
        })
        .then(
          (res) => {
            console.log(res);
            if (res.state === 10000) {
              this.sfc = res.data.prod || [];
            } else {
              this.$message.error(res.msg);
            }
          },
          () => {
            this.$message.error("请求超时");
          }
        );
    },
  },
};
</script>

<style scoped>
/* 全局容器 */
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部图片样式 */
.top-img-wrapper {
  width: 100%;
  overflow: hidden;
}
.top-img-wrapper .wx {
  width: 100%;
  height: auto;
  object-fit: cover;
}

/* 床垫区域样式 */
.mattress-section {
  width: 100%;
  padding: 40px 20px;
  box-sizing: border-box;
}

/* 标题样式 */
.section-title {
  text-align: center;
  margin-bottom: 40px;
}
.main-title {
  font-size: clamp(24px, 3vw, 40px); /* 响应式字体 */
  color: #333;
  margin: 0 0 16px;
  font-weight: 600;
}
.sub-title {
  font-size: clamp(14px, 1.5vw, 16px);
  color: #333;
  line-height: 1.5;
  margin: 0;
}

/* 床垫列表布局 */
.mattress-list {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  /* 响应式网格：最小350px一列，自动适配 */
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px; /* 统一间距 */
  padding: 0 10px;
}

/* 床垫子项样式 */
.mattress-item {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08); /* 更柔和的阴影 */
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}
/* 悬浮效果 */
.mattress-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

/* 图片样式 */
.item-img {
  width: 100%;
  height: 350px; /* 统一高度 */
}
/* 图片占位/错误样式 */
.image-placeholder,
.image-error {
  width: 100%;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  color: #999;
}

/* 描述文字 */
.item-desc {
  font-size: 13px;
  color: #666;
  padding: 12px 15px;
  margin: 0;
  line-height: 1.4;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .mattress-section {
    padding: 20px 10px;
  }
  .section-title {
    margin-bottom: 25px;
  }
  .item-img {
    height: 250px; /* 移动端图片高度适配 */
  }
  .image-placeholder,
  .image-error {
    height: 250px;
  }
  .mattress-list {
    gap: 20px;
  }
}

@media (max-width: 480px) {
  .item-img {
    height: 200px;
  }
  .image-placeholder,
  .image-error {
    height: 200px;
  }
  .mattress-list {
    gap: 15px;
  }
}

/* 清除浮动 */
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
</style>